import { render, staticRenderFns } from "./LotViewSocialShare.vue?vue&type=template&id=2ad0de5a&scoped=true"
import script from "./LotViewSocialShare.vue?vue&type=script&lang=js"
export * from "./LotViewSocialShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad0de5a",
  null
  
)

export default component.exports